import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { LEAGUES } from '@/constants/leagues';
import { Rutas } from '@/constants/rutas';
import { obtenerEquipos } from '@/data/equipos';
import { getTeamImageById } from '@/helpers/images-helper';

import CustomEquipoWithTooltip from '@/DesignSystem/components/partidos/CustomEquipoWithTooltip';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import CustomLink from './custom/custom-link';
import { useEffect, useState } from 'react';
import useGlassStyles from '@/DesignSystem/hooks/styles/useGlassStyles';

const TeamNavigationWrapper = ({ children, glassStyles, theme }) => {
    return (
        <Box
            component="nav"
            display="flex"
            alignItems="center"
            justifyContent={{
                xs: 'flex-start',
                md: 'center',
            }}
            height={{ xs: 50, md: 70 }}
            position={'sticky'}
            top={40}
            zIndex={1200}
            gap={{
                sx: 0,
                md: 0.5,
            }}
            sx={{
                py: 0.5,
                px: 1,
                overflowX: 'auto',
                overflowY: 'hidden',
                // Fallback sólido si no hay soporte de backdrop-filter
                backgroundColor: theme?.palette?.background?.default || theme?.palette?.footer?.background,
                // Sobrescribir con glass cuando hay soporte:
                '@supports (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))': {
                    ...glassStyles,
                },
            }}
        >
            {children}
        </Box>
    );
};

const TeamNavigationComponent = () => {
    const [isHydrated, setIsHydrated] = useState(false);
    const theme = useTheme();
    const glassStyles = useGlassStyles(theme);
    const equipos = obtenerEquipos(LEAGUES.LA_LIGA, false);
    const isNotMobile = useMediaQuery('(min-width: 576px)');
    const size = isNotMobile ? 45 : 35;
    const isPremium = useIsUserPremium();

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return <TeamNavigationWrapper glassStyles={glassStyles} theme={theme} />;
    }

    return (
        <TeamNavigationWrapper glassStyles={glassStyles} theme={theme}>
            {equipos.map((team) => (
                <CustomLink
                    href={`${Rutas.EQUIPO}/${team.slug}`}
                    onMouseEnter={(e) => e.preventDefault()}
                    style={{ position: 'relative' }}
                    key={team.id}
                    prefetch={false}
                    useNativeLink={!isPremium}
                    useWrapper={true}
                    aria-label={`Ver equipo ${team.name}`}
                >
                    <CustomEquipoWithTooltip
                        width={size}
                        height={size}
                        src={getTeamImageById(team.id, size * 1.5)}
                        alt={team.name}
                        loading="eager"
                    />
                    {team.group && (
                        <Typography
                            style={{
                                position: 'absolute',
                                right: '-8px',
                                bottom: '-4px',
                                color: '#fff',
                                fontSize: '10px',
                                opacity: 0.55,
                            }}
                        >
                            {team.group}
                        </Typography>
                    )}
                </CustomLink>
            ))}
        </TeamNavigationWrapper>
    );
};

export default TeamNavigationComponent;
